import { render, staticRenderFns } from "./fastInquiryPay.vue?vue&type=template&id=0b09f6d0&scoped=true&"
import script from "./fastInquiryPay.vue?vue&type=script&lang=ts&"
export * from "./fastInquiryPay.vue?vue&type=script&lang=ts&"
import style0 from "./fastInquiryPay.vue?vue&type=style&index=0&id=0b09f6d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b09f6d0",
  null
  
)

export default component.exports